// SPDX-License-Identifier: FSL-1.1-Apache-2.0
import type {
  ConsentSettings,
  TrackerInstance,
  UserTraits,
} from "@geenius/analytics";

export interface AnalyticsContextOptions {
  optional?: boolean;
}

export interface NativeAnalyticsActions {
  consent: (settings: ConsentSettings) => void;
  deleteUserData: (userId: string) => Promise<void>;
  forgetUser: (userId: string) => Promise<void>;
  identify: (userId: string, traits?: UserTraits) => Promise<void>;
  isReady: boolean;
  page: TrackerInstance["page"];
  reset: TrackerInstance["reset"];
  sessionId: string;
  track: TrackerInstance["track"];
}

export function resolveAnalyticsTracker(
  tracker: TrackerInstance | null,
  options: AnalyticsContextOptions = {},
): TrackerInstance | null {
  if (!tracker && !options.optional) {
    throw new Error(
      "useAnalyticsContext must be called inside an <AnalyticsProvider> tree.",
    );
  }
  return tracker;
}

export function createNativeAnalyticsActions(
  tracker: TrackerInstance,
): NativeAnalyticsActions {
  return {
    track: tracker.track,
    page: tracker.page,
    identify: tracker.identify,
    reset: tracker.reset,
    consent: tracker.consent,
    deleteUserData: tracker.deleteUserData,
    forgetUser: tracker.forgetUser,
    sessionId: tracker.getSessionId(),
    isReady: tracker.isReady(),
  };
}
